const LevelTransformer = (type) => {
  if (type === 'PERSONAL') return 'Personal';
  if (type === 'PREMIUM') return 'Premium';
  if (type === 'CORPORATE') return 'Corporate';

  return type;
}

export default LevelTransformer;
